import { render, staticRenderFns } from "./UploadRejectedDocument.vue?vue&type=template&id=59eb6054"
import script from "./UploadRejectedDocument.vue?vue&type=script&lang=ts"
export * from "./UploadRejectedDocument.vue?vue&type=script&lang=ts"
import style0 from "./UploadRejectedDocument.vue?vue&type=style&index=0&id=59eb6054&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports